import * as React from "react";

import {
  FieldSchema,
  FormControlSchema,
  OtherFieldSchema,
  isAmountFieldSchema,
  isArrayFieldSchema,
  isCheckboxGroupFieldSchema,
  isDateFieldSchema,
  isDynamicFieldSchema,
  isFileFieldSchema,
  isHiddenFieldSchema,
  isObjectFieldSchema,
  isRadioFieldSchema,
  isReadonlyFieldSchema,
  isSelectFieldSchema,
  isTextAreaFieldSchema,
  isTextFieldSchema
} from "@cak-legacy/generation-core";

import { AmountItem } from "../Fields/AmountItem";
import { ArrayField } from "../Fields/ArrayField";
import { CheckboxGroupField } from "../Fields/CheckboxGroupField";
import { DynamicField } from "../Fields/DynamicField";
import { FileField } from "../Fields/FileField";
import { MultiSelectField } from "../Fields/MultiSelectField";
import { ObjectField } from "../Fields/ObjectField";
import { RadioField } from "../Fields/RadioField";
import { ReadItem } from "../Fields/ReadItem";
import { SelectField } from "../Fields/SelectField";
import { withCollapseFieldHoc } from "../Hoc/withCollapseFieldHoc";

export type RenderFieldSchemaComponent = React.ComponentType<
  IRenderFieldProps<FieldSchema | FormControlSchema>
> | null;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface IRenderFieldProps<TFieldSchema> {
  name: string;
  field: FieldSchema;

  renderAddedSchemaFields?: (name: string, field: OtherFieldSchema) => RenderFieldSchemaComponent;
}

export const RenderFields = withCollapseFieldHoc(
  <TFieldSchema extends FieldSchema>(props: IRenderFieldProps<TFieldSchema>) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let Component: any = null;

    if (isArrayFieldSchema(props.field)) {
      Component = ArrayField(props.renderAddedSchemaFields);
    } else if (isObjectFieldSchema(props.field)) {
      Component = ObjectField(props.renderAddedSchemaFields);
    } else if (isSelectFieldSchema(props.field)) {
      Component = props.field.multiSelect === true ? MultiSelectField : SelectField;
    } else if (isRadioFieldSchema(props.field)) {
      Component = RadioField;
    } else if (isCheckboxGroupFieldSchema(props.field)) {
      Component = CheckboxGroupField;
    } else if (isFileFieldSchema(props.field)) {
      Component = FileField;
    } else if (isReadonlyFieldSchema(props.field)) {
      Component = ReadItem;
    } else if (isTextAreaFieldSchema(props.field)) {
      Component = ReadItem;
    } else if (isTextFieldSchema(props.field)) {
      Component = ReadItem;
    } else if (isDateFieldSchema(props.field)) {
      Component = ReadItem;
    } else if (isAmountFieldSchema(props.field)) {
      Component = AmountItem;
    } else if (isDynamicFieldSchema(props.field)) {
      Component = DynamicField;
    } else if (isHiddenFieldSchema(props.field)) {
      return null;
    } else {
      Component = props.renderAddedSchemaFields?.(props.name, props.field) ?? null;
    }

    if (!Component) {
      return null;
    }
    return <Component name={props.name} field={props.field} />;
  }
);
